export type PasswordCheck = { id: string; label: string; ok: (pw: string) => boolean };

export const PASSWORD_RULES: PasswordCheck[] = [
  { id: "len",   label: "mind. 12 Zeichen",                        ok: (pw) => pw.length >= 12 },
  { id: "upper", label: "mind. 1 Großbuchstabe (A–Z)",             ok: (pw) => /[A-Z]/.test(pw) },
  { id: "lower", label: "mind. 1 Kleinbuchstabe (a–z)",            ok: (pw) => /[a-z]/.test(pw) },
  { id: "digit", label: "mind. 1 Zahl (0–9)",                      ok: (pw) => /\d/.test(pw) },
  { id: "sym",   label: "mind. 1 Sonderzeichen (z. B. % _ + ! ?)", ok: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

export function passwordScore(pw: string): number {
  return PASSWORD_RULES.filter((r) => r.ok(pw)).length;
}
